import React, {
    useEffect,
    useState,
    createContext,
    useContext,
    useCallback,
} from 'react'
import { useParams, useHistory } from 'react-router-dom'

import { APIRequestContext } from '../../../wrappers/APIRequestContext'
import withConfig from '../../../wrappers/withConfig'
import { DataContext } from '../DataContext'
import { UserContext } from '../../../wrappers/UserContext'
import actions from '../../../../utils/submissions/actions'

const ExistingDataContext = createContext(null)

const ExistingDataContextProvider = ({ children, config }) => {
    const { authenticatedFetch } = useContext(APIRequestContext)
    const {
        setActiveAgency,
        initializeState,
        submissionState,
        setFacilityID,
        setIsSubmitting,
        setErrorState,
        isLoading,
        setLoading,
        formType,
    } = useContext(DataContext)
    const { user } = useContext(UserContext)
    const { uploadId } = useParams()
    const history = useHistory()
    const [uploadData, setUploadData] = useState({})
    const [uploadChanges, setUploadChangeData] = useState({})
    const [reviewText, setReviewText] = useState(null)
    const { API_URL } = config
    const [denied, setDenied] = useState(false)

    useEffect(() => {
        if (
            actions.isValidFormType(formType) &&
            !(uploadId === null || isNaN(uploadId))
        ) {
            actions.getExistingSubmission(
                authenticatedFetch,
                API_URL,
                uploadId,
                formType,
                setUploadData,
                setLoading
            )
        }
    }, [uploadId, formType])

    useEffect(() => {
        if ((uploadData && uploadData.upload) || uploadData.UploadId) {
            setActiveAgency(uploadData.upload.AgencyCode)
            initializeState(uploadData)
            setErrorState({})
            setFacilityID(uploadData.facility.UploadFacilityID)
        }
    }, [uploadData])

    useEffect(() => {
        if (
            actions.isValidFormType(formType) &&
            formType.Link !== 'merge' &&
            !(uploadId === null || isNaN(uploadId))
        ) {
            actions.getUploadChanges(
                authenticatedFetch,
                API_URL,
                uploadId,
                formType,
                setUploadChangeData
            )
            actions.getReviewText(
                authenticatedFetch,
                API_URL,
                uploadId,
                formType,
                setReviewText
            )
        }
    }, [submissionState, uploadId, formType])

    const rejectUpload = useCallback(
        comments => {
            if (
                !(uploadId === null || isNaN(uploadId)) &&
                user &&
                user.profile
            ) {
                setDenied(true)
                actions.reject(
                    authenticatedFetch,
                    API_URL,
                    history,
                    uploadId,
                    comments,
                    user.profile.name,
                    () => setDenied(false)
                )
            }
        },
        [submissionState, uploadId]
    )

    const approveUpload = useCallback(
        comments => {
            if (
                !(uploadId === null || isNaN(uploadId)) &&
                user &&
                user.profile
            ) {
                const { name, email } = user.profile
                setIsSubmitting(true)
                actions.approve(
                    authenticatedFetch,
                    API_URL,
                    history,
                    uploadId,
                    comments,
                    name,
                    () => setIsSubmitting(false),
                    formType
                )
            }
        },
        [submissionState, uploadId, formType]
    )

    return (
        <ExistingDataContext.Provider
            value={{
                uploadData,
                uploadChanges,
                rejectUpload,
                approveUpload,
                reviewText,
                isLoading,
                denied,
                setDenied,
            }}
        >
            {children}
        </ExistingDataContext.Provider>
    )
}

export { ExistingDataContext }
export default withConfig(ExistingDataContextProvider)
